import { convertDistance } from '@turf/turf';

export type PaceUnit = 'miles' | 'kilometers';
/**
 * Converts a speed value from meters per second to a pace value in seconds per mile/kilometer
 * @param speedInMetersPerSecond - The speed in meters per second to convert
 * @param from - The source unit (currently only supports 'meters')
 * @param to - The target unit to convert to ('miles' or 'kilometers')
 * @returns The converted pace in seconds per mile/kilometer
 */
export function convertPace(
  speedInMetersPerSecond: number,
  from: 'meters',
  to: 'miles' | 'kilometers',
) {
  try {
    // Convert speed (m/s) to pace (seconds per unit)
    // First convert to seconds per meter
    const secondsPerMeter = 1 / speedInMetersPerSecond;
    // Then convert to seconds per target unit
    const convertedSeconds = secondsPerMeter / convertDistance(1, from, to);
    return convertedSeconds;
  } catch (error) {
    console.error(error);
    return speedInMetersPerSecond;
  }
}
